export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_08.3975cca0.jpg";